export * from './IconTopRight';
